import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import {
	fetchCampaignStats,
	fetchCampaignSends,
	fetchCampaignBlockedRecipients,
	fetchCampaignCustomVariables,
} from '../../api/campaignStatisticsApi';

import { emailSendsKeys } from './keys';

export function useCampaignStats(campaignId) {
	return useQuery({
		queryKey: emailSendsKeys.stats(campaignId),
		queryFn: () => fetchCampaignStats(campaignId),
		enabled: Boolean(campaignId),
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});
}

export function useCampaignSends(campaignId, { filters = {}, page = 1, pageSize = 100 } = {}) {
	return useQuery({
		queryKey: emailSendsKeys.sends(campaignId, filters, page, pageSize),
		queryFn: () => fetchCampaignSends(campaignId, { filters, page, pageSize }),
		enabled: Boolean(campaignId),
		staleTime: STALE_TIMES.FREQUENT,
		placeholderData: keepPreviousData,
		retry: 2,
	});
}

export function useCampaignBlockedRecipients(campaignId, { enabled = true } = {}) {
	return useQuery({
		queryKey: emailSendsKeys.blockedRecipients(campaignId),
		queryFn: () => fetchCampaignBlockedRecipients(campaignId),
		enabled: Boolean(campaignId) && enabled,
		staleTime: STALE_TIMES.STANDARD,
	});
}

export function useCampaignCustomVariables(campaignId) {
	return useQuery({
		queryKey: emailSendsKeys.customVariables(campaignId),
		queryFn: () => fetchCampaignCustomVariables(campaignId),
		enabled: Boolean(campaignId),
		staleTime: STALE_TIMES.FREQUENT,
	});
}
